import React from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import NavigationButton from '../shared/Buttons/NavigationButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const PaginationWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
}));

export const CollectionPagination: React.FC<PaginationProps> = (props) => {
    const {
        hasPreviousPage,
        hasNextPage,
        endCursor,
        startCursor,
        handlePagination,
        pagination,
    } = props;

    const nextPage = () => {
        if (hasNextPage) {
            handlePagination(pagination + 1, endCursor, true);
        }
    };

    const previousPage = () => {
        if (hasPreviousPage) {
            handlePagination(pagination - 1, startCursor, false);
        }
    };

    return (
        <PaginationWrapper>
            <NavigationButton
                onClick={previousPage}
                disabled={!hasPreviousPage}
            >
                <ArrowBackIosNewIcon />
            </NavigationButton>
            <NavigationButton onClick={nextPage} disabled={!hasNextPage}>
                <ArrowForwardIosIcon />
            </NavigationButton>
        </PaginationWrapper>
    );
};

type PaginationProps = {
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    endCursor: string;
    startCursor: string;
    handlePagination: (
        pagination: number,
        currentItem: string,
        nextItem: boolean
    ) => void;
    pagination: number;
};
